var debounce = require("lodash/debounce");
const confirmationToast = require("../components/confirmationToast");
const scrollLock = require("../utilities/scrollLock");
import { loadingDotsActivation } from "../components/pageLoading";
const globalUtil = require("../utilities/globalUtilities");
const urlUtils = require("../search/urlUtils");
const mqueryRespond = window.mqRespond;

let checkQuickViewState = false;
var _productToAdd = null;
let addToCartTriggersInSession = 0;
let hasUnavailableProducts = false;
import store from "../vue/components/store";
import {setMaxNumberOfUnitsPerSale} from "../components/quantityHelper";
import { inputAnimationEvents } from "../components/formElementsUtil";
import ProductQtyMap from "../utilities/ProductQtyMap";
import { scrollToElement } from "../utilities/scrollToElement";
import { verifyAndCheckAppliedCarouselCoupons, buildLoyaltyCouponCardList } from "../components/loyaltyUtils";
import { MINICART_QUANTITY_LIMIT } from "../utilities/constants";
import { saveProductNote } from "../product/detail";
import { removeCurrencyFromStringAndConverToNumber } from "../components/convertUtils";

const $cache = {
    document: $(document),
    window: $(window),
    body: $("body"),
    minicartPopover: $(".minicart .ct-popover"),
    unavailableProductsRemoveModal: $("#remove-unavailable-products-modal"),
    consentModal: $("#consent-confirmation-modal"),
    stickySummary: document.querySelector(".ct-cart--summary-wrapper")
};

const isCartPage = $(".cart-page").length;

/**
 * Saves element (add to cart button) to reuse for resume add to cart functionality
 * @param {jquery} productToAdd - DOM container
 */
function setProductToAdd(productToAdd) {
    _productToAdd = productToAdd;
}

/**
 * Returns previously saved element (add to cart button) to reuse for resume add to cart functionality
 * @return {jquery} productToAdd - DOM container
 */
function getProductToAdd() {
    return _productToAdd;
}

/**
 * Handles Close action of modal.
 */
function closeArea() {
    $cache.document.on("click", "#coverage-area-modal button.close", function () {
        updateCartSummaryModalClass(false);
        if (getProductToAdd()) {
            resumeAddToCart(_productToAdd);
        }
    });
}

/**
 * Opens the consent confirmation modal
 */
function initConsentConfirmationPopup() {
    $cache.document.on("click", ".ct-recommendations--continue-btn-container a.button, .checkout-continue a.button", function (e) {
        e.preventDefault();

        const $this = $(this);
        const $consentsCheck = $(".consents-check");
        const consentConfirmed = $consentsCheck.length ? $consentsCheck.data("consent-confirmed") : true;
        const url = $this.attr("href");

        if (consentConfirmed) {
            if ($(".js-out-of-stock-products").length) {
                $cache.unavailableProductsRemoveModal.modal("show");
            } else {
                //Validate Order Request
                if ($this.parent().hasClass("checkout-continue")) {
                    const orderValidateUrl = $this.data("order-validate");
                    $.ajax({
                        url: orderValidateUrl,
                        method: "GET",
                        dataType: "json",
                        success: function (response) {
                            if (response && response.noCoverageAreaSet) {
                                window.location.href = response.redirectUrl;

                                return;
                            }
                            if (response.error) {
                                //continue to next page if no response
                                window.location.href = url;

                                return;
                            }
                            if (response && response.data && response.data.orderItemsValidationResult) {
                                let hasNotAvailableProduct = response.data.orderItemsValidationResult.some(item => item.availableStock == 0 || item.availableStock < item.request.quantity);

                                if (hasNotAvailableProduct) {
                                    //refresh page
                                    window.location.reload();
                                } else {
                                    var numberOfInvalidCoupons = 0;
                                    if (window.mqRespond.status.mobile || window.mqRespond.status.tablet) {
                                        numberOfInvalidCoupons = $cache.document.find(".couponsMobileContainer .coupon-not-applied:not(.coupon-shipping-type)").length;
                                    } else {
                                        numberOfInvalidCoupons = $cache.document.find(".couponsDesktopContainer .coupon-not-applied:not(.coupon-shipping-type)").length;
                                    }
                                    if (numberOfInvalidCoupons > 0) {
                                        displayInvalidCouponsModalWarning(numberOfInvalidCoupons, ($modalBody) => {
                                            $modalBody.find(".confirm").off("click").on("click", () => {
                                                loadingDotsActivation(".js-check-has-unavailable-products");
                                                window.location.href = url;
                                            });
                                        });
                                    } else {
                                        loadingDotsActivation(".js-check-has-unavailable-products");
                                        window.location.href = url;
                                    }
                                }
                                return;
                            }
                        }
                    });
                } else {
                    window.location.href = url;
                }
            }

        } else {
            $cache.consentModal.modal("show");
        }
    });
}

/**
 * Opens the consent confirmation modal when forcefully redirected from cart or checkout
 */
const triggerConsentModalOpen = () => {
    const wrapper = $("[data-open-consent-modal]");

    if (!wrapper.length) {
        return;
    }

    const openConsentModal = $("[data-open-consent-modal]").data("open-consent-modal");
    if (openConsentModal) {
        $cache.consentModal.modal("show");
    }
};

const consentConfirmationBtnClickEvent = () => {
    $cache.document.on("click", ".ct-consent-confirmation-btn", function (e) {
        e.preventDefault();

        const consentForm = document.querySelector(".ct-consent-confirmation-form");
        const actionUrl = consentForm.action;
        const currentTarget = e.currentTarget;
        const redirectUrl = $(".cart-page").length ? currentTarget.dataset?.redirectCheckoutUrl : ($(".js-recommendations").length ? currentTarget.dataset?.redirectCartUrl : null);

        if (actionUrl) {
            $.ajax({
                url: actionUrl,
                method: "POST",
                dataType: "json",
                data: $(consentForm).serialize(),
                success: function (response) {
                    if (response && response.success) {
                        $cache.consentModal.modal("hide");
                        if (hasUnavailableProducts) {
                            $cache.unavailableProductsRemoveModal.modal("show");
                        } else {
                            if (redirectUrl) {
                                window.location.href = redirectUrl;
                            } else {
                                location.reload();
                            }
                        }
                    }
                }
            });
        }
    });
};

/**
 * Enabled/disabled Consent confirmation button depending on the Terms and Conditions input state
 */
const consentTermsAndConditionsInputEvent = () => {
    const consentTermsAndConditionsInput = document.querySelector(".ct-consent-form--privacy-input-modal");

    if (consentTermsAndConditionsInput) {
        consentTermsAndConditionsInput.addEventListener("change", e => {
            const consentConfirmationBtn = document.querySelector(".ct-consent-confirmation-btn");

            consentConfirmationBtn.disabled = !e.currentTarget.checked;
        });
    }
};

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $(".add-to-cart-url").val();
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $("<div>").append($.parseHTML(html));

    var body = $html.find(".choice-of-bonus-product");
    var footer = $html.find(".modal-footer").children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $(".modal-body").spinner().start();

    if ($("#chooseBonusProductModal").length !== 0) {
        $("#chooseBonusProductModal").remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = "<!-- Modal -->"
        + "<div class=\"modal fade\" id=\"chooseBonusProductModal\" tabindex=\"-1\" role=\"dialog\">"
        + "<span class=\"enter-message sr-only\" ></span>"
        + "<div class=\"modal-dialog choose-bonus-product-dialog\" "
        + "data-total-qty=\"" + data.maxBonusItems + "\""
        + "data-UUID=\"" + data.uuid + "\""
        + "data-pliUUID=\"" + data.pliUUID + "\""
        + "data-addToCartUrl=\"" + data.addToCartUrl + "\""
        + "data-pageStart=\"0\""
        + "data-pageSize=\"" + data.pageSize + "\""
        + "data-moreURL=\"" + data.showProductsUrlRuleBased + "\""
        + "data-bonusChoiceRuleBased=\"" + data.bonusChoiceRuleBased + "\">"
        + "<!-- Modal content-->"
        + "<div class=\"modal-content\">"
        + "<div class=\"modal-header\">"
        + "    <span class=\"\">" + data.labels.selectprods + "</span>"
        + "    <button type=\"button\" class=\"close pull-right\" data-dismiss=\"modal\">"
        + "        <span aria-hidden=\"true\">&times;</span>"
        + "        <span class=\"sr-only\"> </span>"
        + "    </button>"
        + "</div>"
        + "<div class=\"modal-body\"></div>"
        + "<div class=\"modal-footer\"></div>"
        + "</div>"
        + "</div>"
        + "</div>";
    $("body").append(htmlString);
    $(".modal-body").spinner().start();

    $.ajax({
        url: bonusUrl,
        method: "GET",
        dataType: "json",
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $("#chooseBonusProductModal .modal-body").empty();
            $("#chooseBonusProductModal .enter-message").text(response.enterDialogMessage);
            $("#chooseBonusProductModal .modal-header .close .sr-only").text(response.closeButtonText);
            $("#chooseBonusProductModal .modal-body").html(parsedHtml.body);
            $("#chooseBonusProductModal .modal-footer").html(parsedHtml.footer);
            $("#chooseBonusProductModal").modal("show");
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Update minicart information
 * @param {Object} data
 */
function updateMinicartInfo(data) {
    if (globalUtil.hasNotAllowedValues(data)) {
        return;
    }
    const basket = data.basket || data;
    const params = urlUtils.parseQueryStringToObject(data.queryString);
    const subTotal = basket?.totals?.totalPriceProductsOnly;
    const hideZeroPrice = basket?.totals?.hideZeroPrice;
    const productID = params.pid;
    const product = basket?.items?.filter(function (item) {
        return item.id == productID;
    })[0];
    const $minicartSubtotal = $(".minicart-estimated-total .minicart-subtotal");
    const $mimimumOrderValue = $(".minicart-minimumOrderValue");
    const priceText = hideZeroPrice === true ? "" : subTotal;
    const campaignObj = basket?.campaignBenefitThreshold;

    if (campaignObj) {
        $(".threshold_campaign").attr("class", campaignObj.mainclass);

        if (campaignObj.show) {
            const campaign = ".campaignBenefitThreshold_message_";
            $(campaign + "add").text(campaignObj.messages.add);
            $(campaign + "value").text(campaignObj.messages.value);
            $(campaign + "addtoget").text(campaignObj.messages.addtoget);
            $(campaign + "discount").text(campaignObj.messages.discount);
            $(campaign + "applied").text(campaignObj.messages.applied);
            $(".threshold_campaign_bar_value").width(campaignObj.percentage);
            $(".campaignBenefitThreshold_message_reached").attr("class", campaignObj.reachedclasses);
        }
    }

    if (product) {
        const itemTotalPrice = product.priceTotal.price;
        $(`.ct-minicart-total-price[data-pid="${productID}"]`).find(".totalPrice").text(itemTotalPrice);
    }

    $minicartSubtotal.text(priceText);

    if (basket.minicartMinimumOrderValueBlocked) {
        $mimimumOrderValue.show();
    } else {
        $mimimumOrderValue.hide();
    }
}

/**
 * @function
 * @description - Initialize window scroll impact on the confirmation popup position
 */
function initWindowScrollImpact() {
    $(window).on("scroll", debounce(function () {
        var $confirmationMessage = $(".add-to-cart-messages"),
            headerElementsHeight = $(".sticky-container").height() + $(".header-wrapper").outerHeight();

        if ($confirmationMessage.length == 0 || !$confirmationMessage.hasClass("show")) {
            return false;
        }

        if ($(window).scrollTop() != 0) {
            $confirmationMessage.css("top", headerElementsHeight);
        } else {
            $confirmationMessage.css("top", headerElementsHeight + $(".header-links").height());
        }
    }, 100));
}

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($("#quick-view-modal").hasClass("show") && !$(".product-set").length) {
        pid = $($el).closest(".modal-content").find(".product-quickview").data("pid");
    } else if ($(".product-set-detail").length || $(".product-set").length) {
        pid = $($el).closest(".product-detail").find(".product-id").text();
    } else if ($($el).closest(".product-tile").length > 0 && $el.data("pid")) {
        pid = $el.data("pid");
    } else {
        const $qvContainer = $el.closest(".js-product-quickview");
        const $container = $qvContainer.length > 0 ? $qvContainer : $(".product-detail").first();
        pid = $container.data("pid");
    }

    return pid;
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $(".bundle-item").each(function () {
        childProducts.push({
            pid: $(this).find(".product-id").text(),
            quantity: parseInt($(this).find("label.quantity").data("quantity"), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    const $productTile = $el.closest(".product-tile");
    const $addToCartQuantity = $productTile.find(".add-to-cart-quantity");
    var $qtySelector = $productTile.find(".ct-tile-quantity .quantity-value-mask");

    // when event is triggered from product tile
    if ($addToCartQuantity.length) {
        $qtySelector = $productTile.find(".quantity-value-mask");
        if ($qtySelector.length === 0) {
            $qtySelector = $(".ct-tile-quantity").find(".quantity-value-mask");
        }

        $qtySelector.val($addToCartQuantity.val() > 0 ? 1 : -1);

        return $qtySelector;
    }

    if ($qtySelector.length === 0) {
        $qtySelector = $(".ct-tile-quantity").find(".quantity-value-mask");
    }
    $qtySelector.val(-1);

    return $qtySelector;
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find(".product-option")
        .map(function () {
            var $elOption = $(this).find(".options-select");
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find("option[value=\"" + urlValue + "\"]")
                .data("value-id");
            return {
                optionId: $(this).data("option-id"),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * @function
 * @description - Handle the PDP mobile add to cart modal behavior
 */
function handlePDPAddToCartModal() {
    var $addToCartContainer = $cache.document.find(".ct-pdp--add-CTA"),
        $quantityInput = $addToCartContainer.find(".add-to-cart-quantity"),
        $noteInput = $addToCartContainer.find(".add-product-note");

    if ($quantityInput.length > 0 && $noteInput.length > 0) {
        $cache.document.on("touchstart", e => {
            const $this = $(e.target);
            const noModalShown = $(".modal.show").length == 0;

            if ($this.hasClass("add-to-cart-quantity") || $this.hasClass("add-product-note")) {
                return;
            }

            const $modalBackground = $(".modal-background");

            if ($quantityInput.is(":focus")) {
                $quantityInput.blur();
            }

            if ($noteInput.is(":focus")) {
                $noteInput.blur();
            }

            if ($cache.body.hasClass("modal-open") && !$cache.body.hasClass("navigation-open") && noModalShown && !$(".minicart-opened").length) {
                $modalBackground.hide();
                $cache.body.removeClass("modal-open");
                scrollLock.disable();
                updateCartSummaryModalClass(false);
            }
        });

        $quantityInput.add($noteInput).off("focus").on("focus", function () {
            var $modalBackground = $(".js-modal-bg");

            $modalBackground.show();
            $cache.body.addClass("modal-open");
            scrollLock.enable();
        });

        $quantityInput.add($noteInput).off("focusout").on("focusout", function () {
            var $modalBackground = $(".js-modal-bg");

            $modalBackground.hide();
            $cache.body.removeClass("modal-open");
            scrollLock.disable();
            updateCartSummaryModalClass(false);
        });

        $noteInput.off("keyup").on("keyup", e => {
            const $this = $(e.currentTarget);
            const $resetButton = $this.siblings(".js-note-reset-button");

            if ($this[0].dataset.savedNote !== "") {
                $resetButton.addClass("d-block");
            } else {
                $resetButton.toggleClass("d-block", $this.val() !== "");
            }
        });
    }
}

/**
 * @function
 * @description - Check product variations status
 * @param {*} $addToCartBtn - Add to cart button
 */
function checkProductVariations($addToCartBtn) {
    var isPDP = $addToCartBtn.parent().hasClass("ct-pdp--add-CTA"),
        isColorSelected = true,
        isSizeSelected = true;

    if (!isPDP) {
        isColorSelected = true;
        isSizeSelected = true;
    }

    var $productVariations = $addToCartBtn.closest("#quick-view-modal").length ? $("#quick-view-modal").find(".ct-pdp--variation-wrapper") : $addToCartBtn.closest(".product-detail").find(".ct-pdp--variation-wrapper");

    $productVariations.each(function () {
        var $this = $(this);

        if ($this.data("attr") === "color") {
            isColorSelected = $this.find(".color-value.selected").length != 0;
        } else if ($this.data("attr") === "size") {
            isSizeSelected = $this.find(".select-size option[data-attr-value]:selected").length != 0;
        }
    });

    return isSizeSelected && isColorSelected;
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response, $this) {
    $(".minicart").trigger("count:update", response);
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        $("body").trigger("product:syncTileData", response.cart || response);
        const $addToCartErrorModal = $("#add-to-cart-error");
        const $noteBtn = $this.siblings(".js-notes-container").find(".expand-note-section");
        const $noteInput = $this.siblings(".js-notes-container").find(".add-note-section");
        const $pdpPage = $(".ct-pdp");

        const errorMaxReached = $this.closest(".ct-tile-quantity-update").find(".error-max-reached");

        if (errorMaxReached !== null && errorMaxReached !== undefined) {
            errorMaxReached.remove();
        }

        if (response.error) {
            const item = response.cart?.items?.find(prd=> +prd.id === $this.data("pid"));
            const maxQuantity = item?.quantityOptions?.maxOrderQuantity;
            const currentQuantity = item?.quantity;
            const isEntregaZero = $this.hasClass("e0-button");

            if (!isEntregaZero
                && maxQuantity !== undefined
                && currentQuantity !== undefined
                && maxQuantity === currentQuantity
            ) {
                const messageTemplate = `
                    <span class="quantity-error pwc-span-error error-max-reached">
                        ${response.messageMaxQtyReached}
                    </span>
                `;
                $this.parent().find(".ct-tile-quantity-update").append(messageTemplate);
            } else {
                const $errorMessageContainer = $(".js-add-to-cart-error-msg");
                if ($errorMessageContainer && $errorMessageContainer.length == 0) {
                    $addToCartErrorModal.attr("data-error-msg", response.message);
                } else {
                    $errorMessageContainer.text(response.message);
                }
                $addToCartErrorModal.modal("show");
            }
        }

        if ((response.isProductInStock) && !response.basketLimitReached) {
            if ($this.hasClass("add-to-cart")) {
                $(`.add-to-cart[data-pid="${$this.attr("data-pid")}"]`).each(function () {
                    const $qtyContainer = $(this).siblings(".ct-tile-quantity");
                    $qtyContainer.removeClass("d-none");
                    $(this).addClass("hide");
                });
            }

            $noteBtn.prop("disabled", false);

            if (window.mqRespond.status.mobile && $noteInput.length) {
                $noteInput.removeClass("d-none");
                $pdpPage.addClass("is-note-shown");
            }

            var currentProd = response.pliUUID;
            var cartItems = ("cart" in response) ? response.cart.items : response.items;
            var product = cartItems?.find(prod => prod.UUID === currentProd);

            if (product && $(".minicart .ct-popover").hasClass("show")) {
                var minicartObj = {
                    cartTotal: response.totals.totalPriceProductsOnly,
                    product: product
                };
                $(".minicart").trigger("minicart:update", minicartObj);
            }

            recommendationE0ContainerHandler($this, response.textRecommendationEZ);
        }

        if (response.minicartDataLayerObject) {
            $(".minicart").trigger("minicart:updateDatalayer", response.minicartDataLayerObject);
        }
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            }
        });
    }
}

/**
 * @function
 * @description - Display the login page if the added product index is right after the product index set in Custom Preferences
 * @param {Integer} triggeringProductIndex - The product index from which we should display the login page
 */
const displayLoginPageAddToCart = triggeringProductIndex => {
    addToCartTriggersInSession++;

    if (addToCartTriggersInSession === (triggeringProductIndex + 1) && addToCartTriggersInSession != 1) {
        return true;
    }

    return false;
};

/**
 * Handles main functionality for product add to cart
 * @param {jquery} prdToAdd - DOM container
 */
function resumeAddToCart(prdToAdd) {
    setProductToAdd(null);
    const isPartOfLastOrder = $(prdToAdd).closest(".last-order").length;
    var addToCartUrl;
    var pid;
    var pidsObj;
    var setPids;
    var $this = prdToAdd;
    var measureOptions;
    var basketItem = null;
    var productQtyMap = getProductQtyMap();
    const isRecommendationPage = $this.parents(".ct-recommendations--product-carousels").length > 0;
    const recommendationCarouselList = isRecommendationPage ? $this.closest(".product-grid-recommendations-wrapper").find(".ct-recommendations--carousel-title").text().trim() : "";
    var list = isRecommendationPage && recommendationCarouselList.length > 0 ? recommendationCarouselList : $this.closest(".gtm-list")?.data("gtm-list");
    var {gtmIndex, gtmList} = getGTMData($this, list);

    confirmationToast.cleanConfirmationToast();

    var $variationError = $this.closest("#quick-view-modal").length ? $("#quick-view-modal").find(".ct-pdp--variation-error") : $this.closest(".product-detail").find(".ct-pdp--variation-error");

    $("body").trigger("product:beforeAddToCart", $this);

    if ($(".set-items").length && prdToAdd.hasClass("add-to-cart-global")) {
        setPids = [];

        $(".product-detail").each(function () {
            if (!prdToAdd.hasClass("product-set-detail")) {
                setPids.push({
                    pid: prdToAdd.find(".product-id").text(),
                    qty: prdToAdd.find(".quantity-select").val(),
                    options: getOptions(prdToAdd)
                });
            }
        });
        pidsObj = JSON.stringify(setPids);
    }

    pid = getPidValue(prdToAdd);

    var $productContainer = prdToAdd.closest(".product-detail");
    if (!$productContainer.length) {
        $productContainer = prdToAdd.closest(".quick-view-dialog").find(".product-detail");
    }

    addToCartUrl = getAddToCartUrl();

    if (!checkProductVariations($this) && $this.closest(".product-tile").length == 0) {
        $variationError.removeClass("d-none");
        $(".ct-pdp--variation-error-add-favorite").addClass("d-none");

        if (window.mqRespond.status.mobile) {
            scrollToElement($(".ct-pdp--variations-wrapper"), "slow");
        }

        $.spinner().stop();
        return false;
    }

    if (productQtyMap.items && productQtyMap.items.length) {
        basketItem = productQtyMap.items.find(el => pid && el.id == pid.toString());
        measureOptions = $this.parent().find(".quantity-update").data("measure-options");
    }

    var form = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: getChildProducts(),
        quantity: (basketItem && measureOptions) ? measureOptions.stepQuantity : getQuantitySelected(prdToAdd),
        dimension: measureOptions?.secondaryUnit,
        isCart: isCartPage,
        gtmList: gtmList,
        gtmIndex: gtmIndex
    };

    if (isPartOfLastOrder) {
        form.quantity = prdToAdd.attr("data-quantity-value");
    }

    if (!$(".bundle-item").length && $productContainer.length) {
        form.options = getOptions($productContainer);
    }

    prdToAdd.trigger("updateAddToCartFormData", form);

    var $qtyContainer = $this.parent().find(".ct-tile-quantity");
    const isEntregaZero = $this.hasClass("e0-button");

    if (!isEntregaZero && basketItem && measureOptions && basketItem.quantity === measureOptions.maxNumberOfUnitsPerSale) {
        // hide the button and show the quantity input
        $this.addClass("d-none");
        $qtyContainer.removeClass("d-none");
        triggerCartUpdate();
        $.spinner().stop();
    } else {
        if (addToCartUrl) {
            $.ajax({
                url: addToCartUrl,
                method: "POST",
                data: form,
                success: function (data) {
                    const isVueInitialized = !$qtyContainer.find("template").length;
                    const $quickViewContainer = $(".js-product-quickview");

                    if (!isVueInitialized) {
                        globalUtil.initializeQtyComponent(pid);
                    }

                    if (data && data.productInventoryAllocation) {
                        setMaxNumberOfUnitsPerSale(pid, data.productInventoryAllocation);
                    }

                    if (data && data.error && !data.isProductInStock) {
                        var base = require("../product/base");
                        base.initAddToCartButtonState(data, prdToAdd);
                        base.updatePDPPageOutOfStockState();
                        const $tileContainer = prdToAdd.closest(`.pid-${pid}`);
                        if ($tileContainer.length > 0) {
                            $tileContainer.addClass("ct-product-tile-out-of-stock");
                        }

                    } else if (data) {
                        handlePostCartAdd(data, $this);
                        $("body").trigger("product:afterAddToCart", data);
                        updateProductQtyMap(data.cart);
                        setQuickViewState($this, true);
                        triggerCartUpdate();
                    }

                    $("#quick-view-modal").modal("hide");
                    updateCartSummaryModalClass(false);

                    if (pid && $quickViewContainer && $quickViewContainer.length > 0 && prdToAdd.closest(".js-product-quickview").length > 0) {
                        getNotesArea(pid);
                    }

                    $.spinner().stop();
                    miniCartReportingUrl(data.reportingURL);

                    // Reset add product note input state and note icon
                    const isProductDetailPDP = $(`.product-detail[data-pid="${pid}"]`).length;
                    const isNotMobile = !window.mqRespond.status.mobile;

                    if (isProductDetailPDP && !data.error) {
                        if (isNotMobile) {
                            const $noteAddIconWrapper = $(".js-notes-container").find(".add-note");

                            if ($noteAddIconWrapper.length && $noteAddIconWrapper.hasClass("d-none")) {
                                $noteAddIconWrapper.removeClass("d-none");
                            }
                        }
                    }

                    // Add message max quantity reached
                    if (data.messageMaxQtyReached && !data.error) {
                        let quantityError = ($this.parent().find(".ct-tile-quantity-update")).find(".quantity-error");
                        if (quantityError.length == 0) {
                            const messageTemplate = `
                            <span class="quantity-error pwc-span-error error-max-reached">
                                ${data.messageMaxQtyReached}
                            </span>
                            `;
                            $this.parent().find(".ct-tile-quantity-update").append(messageTemplate);
                        }
                    }

                    //data layer event - start
                    if (data.dataLayerObject) {
                        document.dispatchEvent(new CustomEvent("dataLayer.addToCart", {
                            detail: {
                                "dataLayerObject": data.dataLayerObject
                            }
                        }));
                    }
                    //data layer event - end
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    }
}

/**
 * Function that hides the E0 container from Recommendations page after being added to cart
 * @param {jquery} productToAddToCart - DOM container
 */

const recommendationE0ContainerHandler = (productToAddToCart, textRecommendationEZ) => {
    const $recommendationPage = productToAddToCart.closest(".recommendations-entrega-zero");
    const ezProductsCount = $recommendationPage.find(".ct-product-tile--entrega-zero-product").length;

    if (!$recommendationPage.length) { return; }

    if (ezProductsCount == 1) {
        const cartButtonTextContainer = productToAddToCart.find(".add-to-cart--text");
        const buySectionContainer = productToAddToCart.closest(".pwc-tile-buy-section");
        const quantityContainer = buySectionContainer.find(".ct-tile-quantity");

        if (textRecommendationEZ) {
            cartButtonTextContainer.text(textRecommendationEZ);
        }
        productToAddToCart.addClass("button--primary-inactive").removeClass("button--primary");
        productToAddToCart.prop("disabled", "disabled");
        productToAddToCart.removeClass("hide");
        productToAddToCart.addClass("d-none d-sm-block");
        quantityContainer.addClass("d-none");
    }
};

/**
 * Function that checks if we have an Entrega Zero Product in basket and toggles confirmation modal
 * @param {jquery} productToAddToCart - DOM container
 * @param {boolean} isPartOfEntregaZeroAccountProductList - If products Entrega Zero where added from My Product List Page
 * @param {boolean} isEntregaStaticPage - If products Entrega Zero where added from Entrega Zero Static Page
 */
async function checkAndHandleEntregaZeroProducts(productToAddToCart, isEntregaStaticPage, isPartOfEntregaZeroAccountProductList) {
    const checkIfEzInCartUrl = $(".js-cart-check-entrega-zero-in-cart-url").attr("data-url");

    try {
        const checkForEntregaZero = await fetch(checkIfEzInCartUrl);
        if (!checkForEntregaZero.ok) {
            throw new Error(checkForEntregaZero.statusText);
        }

        if (checkForEntregaZero.ok) {
            const result = await checkForEntregaZero.json();
            const ezProductIdToAdd = productToAddToCart.data("pid");
            const $recommendationPage = productToAddToCart.closest(".recommendations-entrega-zero");
            const ezProductsCount = $recommendationPage.find(".ct-product-tile--entrega-zero-product").length;

            if (!result || !result.id) {
                resumeAddToCart(productToAddToCart);
                return;
            }

            if (result.id == ezProductIdToAdd) {
                resumeAddToCart(productToAddToCart);
                return;
            }

            $("#entrega-zero-replace-modal").modal("show");

            $("#entrega-zero-replace-modal").on("shown.bs.modal", () => {
                // add event to swap EZ products in basket on customers confirmation
                $("#confirm-swap-entrega-zero").off("click").on("click", () => {
                    const EZProductInfo = {
                        id: result.id,
                        ezProductIdToAdd: ezProductIdToAdd,
                        recommendationPageLength: $recommendationPage.length,
                        ezProductsCount: ezProductsCount,
                        isPartOfEntregaZeroAccountProductList: isPartOfEntregaZeroAccountProductList,
                        isEntregaStaticPage: isEntregaStaticPage
                    };
                    triggerProductRemoval(result.id, result.uuid, false, EZProductInfo);
                });
            });

            $cache.body.off("cart:substitutionProductRemoved").on("cart:substitutionProductRemoved", () => {
                resumeAddToCart(productToAddToCart);
                if ($recommendationPage.length) {
                    if (result.id != ezProductIdToAdd && ezProductsCount == 1) {
                        $(".ct-recommendations--entregazero-container").addClass("d-none");
                        return;
                    }
                    $recommendationPage.find(`.pid-${ezProductIdToAdd}`).closest(".ct-recommendations--entregazero-product").addClass("d-none");
                    $recommendationPage.find(`.pid-${result.id}`).closest(".ct-recommendations--entregazero-product").removeClass("d-none");
                }
            });
        }
    } catch (error) {
        if (error) window.location.reload();
    }
}
/**
 * @function
 * @description - Handle add to cart activity based on store context set.
 * Adds product to basket immediately if store context set.
 * Triggers delivery modal if no store context set.
 */
function addToCart() {
    $cache.document.on("click", "button.add-to-cart, button.add-to-cart-global", function () {
        const $this = $(this);
        const isPDPMainSectionClick = $this.closest(".js-product-quickview").length == 0 && $(".product-detail").length > 0;
        const isQuickview = $this.closest(".quick-view-dialog").length > 0;
        const triggeringProductIndex = parseInt(document.querySelector(".js-product-number-trigger-area-de-entrega").dataset.productIndex, 10);
        const isEntregaStaticPage = document.body.contains(document.querySelector(".js-ct-entrega-zero-products"));
        const isPartOfEntregaZeroRecommendations = $(this).closest(".recommendations-entrega-zero").length;
        const myProductsList = $(".js-my-products-list--product-container");

        // Collects analytics information for this product
        const dw = window.dw || null;
        if (dw) {
            dw.ac.capture({ id: $(this).attr("data-pid"), type: dw.ac.EV_PRD_DETAIL });
        }

        // Products Entrega Zero
        const isPartOfEntregaZeroAccountProductList = myProductsList.find(".ct-product-tile--entrega-zero-product").length;

        if (isEntregaStaticPage || isPartOfEntregaZeroRecommendations || isPartOfEntregaZeroAccountProductList) {
            const isCompanyCustomer = $(".ct-popover").data("is-company-customer");

            if (isCompanyCustomer) {
                $("#entrega-zero-company-customer-notification").modal("show");
                return;
            }

            checkAndHandleEntregaZeroProducts($this, isEntregaStaticPage, isPartOfEntregaZeroAccountProductList > 0);
            return;
        }

        if ($(".store-context-info").first().text() === "false") {

            if (isQuickview && !checkProductVariations($this)) {
                resumeAddToCart($this);
            } else {
                checkQuickViewState = $this.closest("#quick-view-modal").length > 0;

                if (!isPDPMainSectionClick) {
                    $("#quick-view-modal").modal("hide");
                    updateCartSummaryModalClass(false);
                }

                if (triggeringProductIndex <= 1 || displayLoginPageAddToCart(triggeringProductIndex)) {
                    const registrationLinkElem = document.querySelector(".ct-user-dropdown--registration-link");
                    const url = registrationLinkElem && registrationLinkElem.getAttribute("href");

                    window.sessionStorage.setItem("url-after-login", window.location.href);

                    if (url) {
                        window.location.href = url;
                    }
                } else {
                    resumeAddToCart($this);
                }
            }
            return;
        } else {
            checkQuickViewState = false;
            resumeAddToCart($this);
        }
    });

    if (window.mqRespond.status.mobile) {
        handlePDPAddToCartModal();
    }
    initWindowScrollImpact();
}

/**
 * Returns the productqtymap data attribute with items from current basket
 * @return {string} - productqtymap data attribute with items from current basket
 */
const getProductQtyMap = () => {
    return ProductQtyMap;
};

/**
 * Updates the productqtymap data attribute with items from current basket
 * @param {object} basketData - basket object
 */
const updateProductQtyMap = (basketData) => {
    let productQtyMap = {};
    productQtyMap.items = [];

    if (basketData && basketData.items && basketData.items.length > 0) {
        basketData.items.forEach(function (item) {
            productQtyMap.items.push({
                id: item.id,
                quantity: item.quantity,
                UUID: item.UUID,
                selectedDimension: item.selectedDimension
            });
        });
    }

    ProductQtyMap.refreshItems(productQtyMap.items);
    $(".minicart .ct-popover").attr("data-productqtymap", JSON.stringify(productQtyMap));
};

/**
 * Refreshes the ProductQtyMap object
 * @param {Array} basketItems - basket items
 */
const refreshProductQtyMap = basketItems => {
    ProductQtyMap.refreshItems(basketItems);
};

/**
 * Callback function used after a successful quantity update
 * @param {object} data - callback response object
 * @param {object} el - target element
 */
const updatedQuantityCallback = (data, el) => {
    confirmationToast.cleanConfirmationToast();
    $cache.body.trigger("product:afterAddToCart", data);
    handlePostCartAdd(data, $(el));
    updateProductQtyMap(data);
    triggerCartUpdate();
    miniCartReportingUrl(data.reportingURL);
    updateMinicartInfo(data);
    setCartNotesDisplay();
};

/**
 * Updates the total price for product line item on the cart page
 * @param {String} productUUID - productUUID
 * @param {Object} data - data response from request
 */
const updateCartPriceInformation = (productUUID, data) => {
    if ($(".js-cart-page").length == 0) { return; }

    const $priceElement = $(`.line-item-total-price-amount[data-uuid="${productUUID}"]`);

    if (!$priceElement?.length) { return; }

    const targetItem = data.items.find(item => item.UUID == productUUID);
    const { priceTotal } = targetItem;
    const { price = $priceElement.text() } = priceTotal;

    $priceElement.text(price);

    const cartSubTotal = data?.totals?.subTotal;
    const cartGrandTotal = data?.totals?.grandTotal;

    if (cartSubTotal && cartGrandTotal) {
        const $summaryWrapper = $(".ct-cart--summary-wrapper");

        $summaryWrapper.find(".js-total-value").text(cartSubTotal);
        $summaryWrapper.find(".js-cart-subtotal").text(cartGrandTotal);

        if (data.totalProductDiscount) {
            $summaryWrapper.find(".js-poupa-discount").text(data.totalProductDiscount);
        } else {
            $summaryWrapper.find(".js-poupa-area").addClass("d-none");
        }

        const orderLevelDiscountTotal = data?.totals?.orderLevelDiscountTotal;
        if (orderLevelDiscountTotal) {
            if (orderLevelDiscountTotal.value > 0) {
                $summaryWrapper.find(".js-summary-order-level-discount").removeClass("d-none");
                $summaryWrapper.find(".js-order-level-discount-value").text("- " + orderLevelDiscountTotal.formatted);
            } else {
                $summaryWrapper.find(".js-summary-order-level-discount").addClass("d-none");
            }
        }

        adjustSummaryBlocks();
    }
};

/**
 * Update the Product Map on Vue side
 */
const triggerCartUpdate = () => {
    store.commit("setProductMap", getProductQtyMap());
};

/**
 * Reset product note input and dot
 */
const resetProductNote = () => {
    const $noteInput = $("#add-product-note-input");
    const $noteAddDot = $(".expand-note-section").find(".available-note");

    $noteInput.val("");
    $noteInput.attr("data-saved-note", "");
    $noteInput.removeClass("filled");

    if ($noteAddDot.length) {
        $noteAddDot.addClass("d-none");
    }
};

/**
 * Reset product note input and dot
 * @param {Object} EZProductInfo - Information about EZ products
 */
const triggerSubstitutionEZProducts = EZProductInfo => {
    if (!Object.keys(EZProductInfo).length) { return; }
    const { id, ezProductIdToAdd, recommendationPageLength, ezProductsCount, isEntregaStaticPage, isPartOfEntregaZeroAccountProductList } = EZProductInfo;

    if (id != ezProductIdToAdd && ((recommendationPageLength && ezProductsCount == 1) || isEntregaStaticPage || isPartOfEntregaZeroAccountProductList)) {
        $cache.body.trigger("cart:substitutionProductRemoved");
    }
};

/**
 * Trigger the Product Removal action
 * @param {string} productID - Product ID
 * @param {string} uuid - Product UUID
 * @param {boolean} isSubstitution - Triggered by product substitution action
 */
const triggerProductRemoval = (productID, uuid, isSubstitution = false, EZProductInfo = {}) => {
    confirmationToast.cleanConfirmationToast();

    if ($(".minicart .ct-popover").hasClass("show")) {
        const $removeProdBtn = $(`.minicart-remove-product[data-pid="${productID}"]`);

        if ($removeProdBtn.length) {
            $removeProdBtn.first().trigger("click");
        }
    } else {
        const $deleteConfirmBtn = $(`.tile-delete-confirmation-btn[data-pid="${productID}"]`).first();

        if ($deleteConfirmBtn.length) {
            const removeUrl = $(`.product-qty-vue[data-pid="${productID}"]`).data("remove-action");
            $deleteConfirmBtn.data("action", removeUrl);
            $deleteConfirmBtn.data("uuid", uuid);

            if (isSubstitution) {
                $deleteConfirmBtn.addClass("js-substitution-triggered");
            }

            $($deleteConfirmBtn).trigger("click");

            resetProductNote(); // Reset add product note
            triggerSubstitutionEZProducts(EZProductInfo);
            return;
        }

        //for case when we have only one E0 product in Recommendation page set in slot
        if (!$deleteConfirmBtn.length && isSubstitution) {
            const removeProductWithoutButtonUrl = $(".js-remove-product-without-button-url").data("url");
            const urlParams = {
                pid: productID,
                uuid: uuid
            };

            const url = urlUtils.appendToUrl(removeProductWithoutButtonUrl, urlParams);
            try {
                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        //GTM remove from cart event - start
                        if (data.dataLayerObject) {
                            document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", {
                                detail: {
                                    "dataLayerObject": data.dataLayerObject
                                }
                            }));
                        }
                        //GTM remove from cart event - end
                        triggerSubstitutionEZProducts(EZProductInfo);
                    });
            } catch (e) {
                console.error(e);
            }
        }
    }
};

/**
 * Displays the Qty Input Container
 * @param {string} prodID - Product ID
 * @param {boolean} [additionalTag] - optional additional tag
 */
const displayQtyInput = (prodID, additionalTag) => {
    var selector = !additionalTag ? ":not('.tile')" : "." + additionalTag;
    var $pdpQtyContainer = $(`.ct-tile-quantity${selector}[data-pid="${prodID}"]`);

    if ($pdpQtyContainer.length) {
        $pdpQtyContainer.removeClass("d-none");
    }
};

/**
 * Displays the Confirmation Toast
 * @param {object} _el - target element
 * @param {string} quantity - formatted value with units
 */
const displayConfirmationToast = (_el, _quantity) => {
    if ($cache.minicartPopover.hasClass("show") || $cache.minicartPopover.hasClass("not-show-confirmation-toast")) {
        return false;
    }

    confirmationToast.cleanConfirmationToast();
};

/**
 * Updates the cart summary
 * @param {Object} data
 */
const updateCartSummary = data => {
    if (!data) { return; }

    const $totalProductsNumberArea = $(".js-products-number-area");
    const $acumulaArea = $(".js-acumula-area");
    const $poupaArea = $(".js-poupa-area");
    const $couponsArea = $(".js-coupon-discount-area");
    const $plasticBagsArea = $(".js-plastic-bags-area");
    const $summarySubtotal = $(".ct-cart--subtotal");
    const $orderDiscountArea = $(".js-summary-order-level-discount");
    const $shippingCostArea = $(".shipping-total-cost");

    if ($(".js-cart-page").length == 0) {
        if (data?.items?.length) {
            data.items.forEach((item) => {
                if (item.renderedPromotions) {
                    $(`.item-${item.UUID}`).empty().append(item.renderedPromotions);
                }
                if (item.priceTotal && item.priceTotal.renderedPrice) {
                    $(`.item-total-${item.UUID}`).empty().append(item.priceTotal.renderedPrice);
                }
                if ($(`#quantity-${item.UUID}`).val() != item.quantity) {
                    $(`#quantity-${item.UUID}`).val(item.quantity);
                }
            });
        }
    }

    if (data.isMinimumOrderValueBlocked) {
        $(".checkout-btn").attr("disabled", true);
        $(".ct-cart--checkout-mov").removeClass("d-none");
    } else {
        $(".checkout-btn").removeAttr("disabled");
        $(".ct-cart--checkout-mov").addClass("d-none");
    }

    if (data.totalNumberOfProducts) {
        $totalProductsNumberArea.find(".js-number-of-items").empty().append(`(${data.totalNumberOfProducts})`);
        $totalProductsNumberArea.find(".js-total-value").empty().append(data.totals.totalPriceProductsOnly);

        const cartTotal = data.cartTotal || data.totalProductsValue;
        const cartGrandTotal = data.totals.grandTotal || cartTotal;

        $summarySubtotal.find(".js-total-value").text(cartTotal);
        $summarySubtotal.find(".js-cart-subtotal").text(cartGrandTotal);
    } else {
        $totalProductsNumberArea.find(".js-number-of-items").empty();
        $totalProductsNumberArea.find(".js-total-value").empty();
    }

    $totalProductsNumberArea.toggleClass("d-none", !data.totalNumberOfProducts);

    if (data.totalAcumulaDiscount && data.totalAcumulaDiscount != "N/A" && data.totalAcumulaDiscount != "0,00" && data.totalAcumulaDiscount != "0.00") {
        data.totalAcumulaDiscount = removeCurrencyFromStringAndConverToNumber(data.totalAcumulaDiscount);
    }

    if (data.totalAcumulaDiscount != null && data.totalAcumulaDiscount != "N/A" && data.totalAcumulaDiscount != "0,00" && data.totalAcumulaDiscount != "0.00") {
        $acumulaArea.find(".total-discount-value").empty().append("€" + data.totalAcumulaDiscount);
        $acumulaArea.removeClass("d-none");
    } else {
        $acumulaArea.find(".total-discount-value").empty();
        $acumulaArea.addClass("d-none");
    }

    if (data.totalProductDiscount != null && data.totalProductDiscount != "N/A" && data.totalProductDiscount != "0,00" && data.totalProductDiscount != "0.00") {
        $poupaArea.find(".total-discount-value").empty().append(data.totalProductDiscount);
        $poupaArea.removeClass("d-none");
    } else {
        $poupaArea.find(".total-discount-value").empty();
        $poupaArea.addClass("d-none");
    }

    if (data && data.totals && data.totals.couponLevelDiscountTotal != null) {
        $couponsArea.find(".total-discount-value").empty().append(`- ${data.totals.couponLevelDiscountTotal}`);
    } else {
        $couponsArea.find(".total-discount-value").empty();
    }

    $couponsArea.toggleClass("d-none", data?.totals?.couponLevelDiscountTotal == null);

    if (data && data.totals && data.totals.orderLevelDiscountTotal.value > 0) {
        $orderDiscountArea.find(".js-order-level-discount-value").empty().append(`- ${data.totals.orderLevelDiscountTotal.formatted}`);
    }
    $orderDiscountArea.toggleClass("d-none", data?.totals?.orderLevelDiscountTotal.value == 0);

    if (data.numberOfPlasticBags && data.numberOfPlasticBags > 0) {
        $plasticBagsArea.find(".js-number-of-items").empty().append(`(${data.numberOfPlasticBags})`);
        $plasticBagsArea.find(".total-discount-value").empty().append(data.plasticBagsTotalValue);
    } else {
        $plasticBagsArea.find(".js-number-of-items").empty();
        $plasticBagsArea.find(".total-discount-value").empty();
    }

    if (data && data.totals && data.totals.totalShippingCost) {
        $shippingCostArea.empty().append(data.totals.totalShippingCost);
    }

    $plasticBagsArea.toggleClass("d-none", !data.numberOfPlasticBags && data.numberOfPlasticBags <= 0);

    adjustSummaryBlocks();

    updateEZCartMessage(data);
};

/**
 * @function
 * @description - Adjust the product list and mobile Entrega zero bottom spacing, on mobile and tablet, depending on how much space does the summary container occupies
 */
const adjustProductListBottomSpacing = () => {
    const $cartProductList = document.querySelector(".ct-cart--product-list") || document.querySelector(".checkout-page-content--wrapper");
    const $mobileEntregaZero = document.querySelector(".ct-cart--mobile-entrega-zero");
    const isMobileOrTablet = window.mqRespond.status.mobile || window.mqRespond.status.tablet;

    if (!$cartProductList) {
        return;
    }

    if (isMobileOrTablet) {
        const mobileEntregaZeroHeight = $mobileEntregaZero ? $mobileEntregaZero.offsetHeight : 0;
        const $summaryWrapper = document.querySelector(".ct-cart--summary-wrapper");

        if (!$summaryWrapper) return;

        const summaryWrapperHeight = $summaryWrapper.offsetHeight;
        const footerHeight = document.getElementById("footercontent").offsetHeight;
        $cartProductList.style.paddingBottom = `${mobileEntregaZeroHeight + summaryWrapperHeight - footerHeight}px`;
    } else {
        $cartProductList.style.removeProperty("paddingBottom");
    }
};

/**
 * Updates the Entrega Zero message according to the treshold and cart total
 * @param {Object} data
 */
const updateEZCartMessage = data => {
    const $ezMessageContainer = $(".ez-threshold-message");
    if (!$ezMessageContainer) {
        return;
    }

    const isEntregaZeroCustomer = $ezMessageContainer.data("entrega-zero-customer");
    if (!isEntregaZeroCustomer) {
        return;
    }

    const ezProducts = $ezMessageContainer.data("entrega-zero-products");
    const cartTotal = data.totals.grandTotalNumber;
    const threshold = Number($ezMessageContainer.data("threshold"));
    const $mobileSummaryMinQty = $(".ezInsideTotals");
    const $cartSummaryEz = $(".ez-in-summary");
    $ezMessageContainer.empty();

    const hasEzInCart = data && data.items && data.items.some(item => {
        return ezProducts.indexOf(item.id) != -1;
    });

    if (hasEzInCart && data && data.items && data.items.length == 1) {
        return;
    }

    if (cartTotal > threshold) {
        const overThresholdMessage = $ezMessageContainer.data("over-threshold-message");
        const span = `<span>${overThresholdMessage}</span>`;
        $ezMessageContainer.append(span);
        $mobileSummaryMinQty.removeClass("d-flex").addClass("d-none");
        $cartSummaryEz.removeClass("d-none").addClass("d-flex");
    } else {
        const belowThresholdMessageShort = $ezMessageContainer.data("below-threshold-message-short");
        const belowThresholdMessageLong = $ezMessageContainer.data("below-threshold-message-long");
        const shortSpan = `<span class="below-threshold-message d-md-none">${belowThresholdMessageLong}</span>`;
        const longSpan = `<span class="below-threshold-message d-none d-md-block">${belowThresholdMessageShort}</span>`;
        $ezMessageContainer.append(shortSpan);
        $ezMessageContainer.append(longSpan);
        $mobileSummaryMinQty.removeClass("d-none").addClass("d-flex");
        $cartSummaryEz.removeClass("d-flex").addClass("d-none");

        adjustProductListBottomSpacing();
    }

    $ezMessageContainer.toggleClass("ct-cart--entrega-zero-inferior", cartTotal < threshold);
    $(".ct-cart--entrega-zero-icon").removeClass("d-none").toggleClass("ct-cart--entrega-zero-icon-active", cartTotal > threshold);
    $(".ct-cart--summary-info-block.align-items-center").toggleClass("justify-content-start", cartTotal < threshold);
};

/**
 * Defines the product price template used to update the product pricing area when ajax call are performed and impact the product tiles prices (Cart page)
 * @param {Object} product
 */
const productPriceTemplate = product => {
    if (product) {
        const {pricePerUnit} = product;
        const primaryUnit = pricePerUnit && pricePerUnit.primaryPrice && pricePerUnit.primaryPrice.unit ? "/" + pricePerUnit.primaryPrice.unit : "";
        const priceTotal = product.priceTotal;
        const secondaryUnit = pricePerUnit && pricePerUnit.secondaryPrice && pricePerUnit.secondaryPrice.unit ? "/" + pricePerUnit.secondaryPrice.unit : "";
        const secondaryPrice = pricePerUnit && pricePerUnit.secondaryPrice && pricePerUnit.secondaryPrice.price ? pricePerUnit.secondaryPrice.price : "";
        const {basePriceValue, promoUnitPrice, basePrice} = priceTotal;
        const priceReducedFromLabel = $(".js-cart-resources").attr("data-price-reduced-from");
        const priceReducedToLabel = $(".js-cart-resources").attr("data-price-reduced-to");

        return `
            <div class="price">
                <div class="prices-wrapper">
                    <span class="sales pwc-tile--price-primary ">
                        <span class="value" content="${promoUnitPrice || ""}">
                            <span class="ct-price-formatted">
                                ${promoUnitPrice || ""}
                            </span>
                            <span class="pwc-m-unit">
                                ${primaryUnit}
                            </span>
                        </span>
                    </span>
                    <span class="strike-through list pwc-tile--price-dashed ${basePriceValue && promoUnitPrice && basePriceValue != promoUnitPrice ? "" : "d-none"}">
                        <span class="value pwc-tile--price-value" content="${basePriceValue ? basePriceValue : ""}">
                            <span class="sr-only">
                                ${priceReducedFromLabel}
                            </span>
                            ${basePrice ? basePrice : ""}
                            <span class="pwc-tile--price-dashed">
                                ${primaryUnit}
                            </span>
                            <span class="sr-only">
                                ${priceReducedToLabel}
                            </span>
                        </span>
                    </span>
                </div>
                <div class="pwc-tile--price-secondary ${secondaryPrice ? "" : "d-none"}">
                    <span class="ct-price-value">
                        ${secondaryPrice}
                    </span>
                    <span class="pwc-m-unit">
                        ${secondaryUnit}
                    </span>
                </div>
            </div>
        `;
    }

    return "";
};

/**
 * Spinner functionalities
 */
const startSpinner = () => $.spinner().start();
const stopSpinner = () => $.spinner().stop();

const init = () => {
    $cache.document.ready(function () {
        addToCart();
        closeArea();
        initConsentConfirmationPopup();
        triggerConsentModalOpen();
    });
};

/**
 * Toggles the quick view modal visibility for coverage area modals interactions
 * @param {Object} prdToAdd
 * @param {boolean} initVue
 */
const setQuickViewState = (prdToAdd, initVue) => {
    const triggeredFromQuickView = prdToAdd.closest(".quick-view-dialog").length;
    if (!triggeredFromQuickView || !checkQuickViewState) { return; }

    if (initVue) {
        initQuickViewQtyInput(prdToAdd);
    }
};

/**
 * Initialize/stores the quantity vue input for quickview
 * @param {Object} prdToAdd
 */
const initQuickViewQtyInput = prdToAdd => {
    if (checkProductVariations(prdToAdd)) {
        const $qvModal = $("#quick-view-modal");
        const $qtyContainer = $qvModal.find(".ct-tile-quantity");
        const pid = $(".js-product-quickview").data("pid");
        const isVueInitialized = !$qtyContainer.find("template").length;

        if (!isVueInitialized) {
            globalUtil.initializeQtyComponent(pid, "#quick-view-modal");
        }
    }
};

/**
 * @function
 * @description - Set cart notes container width and position
 */
const setCartNotesDisplay = () => {
    const $cartTiles = document.querySelectorAll(".ct-cart-tile");
    setTimeout(() => {
        $cartTiles.forEach(cartTile => {
            const cartTileNotesInitialPos = cartTile.querySelector(".ct-cart-tile-notes") ? cartTile.querySelector(".ct-cart-tile-notes").getBoundingClientRect().left : 0;
            const cartTileSubstitutionsEndPos = cartTile.querySelector(".ct-cart-tile-substitutions") ? cartTile.querySelector(".ct-cart-tile-substitutions").getBoundingClientRect().right : 0;
            const notesWidth = cartTileSubstitutionsEndPos - cartTileNotesInitialPos;
            const productNotesEnabled = cartTile.querySelector(".notes-enabled-js");
            const $cartNotesInput = cartTile.querySelectorAll(".ct-cart-tile-notes-input");

            if (productNotesEnabled) {
                cartTile.classList.add("ct-cart-tile-has-note-js");
            } else {
                cartTile.classList.remove("ct-cart-tile-has-note-js");
            }

        
            $cartNotesInput.forEach(element => {
                element.style.width = notesWidth + "px";
            });
        });
    }, 1500);
};

/**
 * Get notes area
 * @param {String} productID
 */
const getNotesArea = productID => {
    var url = $(".js-product-notes-url").attr("data-url");

    if (url) {
        $.ajax({
            url: url,
            method: "GET",
            data: {
                pid: productID
            },
            success: function (response) {
                var $addToCartBtn = $(`.js-add-to-cart-button[data-pid="${productID}"]`);

                if ($addToCartBtn.length && response) {
                    const $quickViewContainer = $(".js-product-quickview");
                    $addToCartBtn.after(response);

                    if ($quickViewContainer && $quickViewContainer.length) {
                        $addToCartBtn.closest(".js-product-quickview").find(".js-notes-container .add-note").removeClass("d-none");
                    }

                    inputAnimationEvents();
                    saveProductNote();
                }
            }
        });
    }
};

/**
 * Adjusted the cart summary values blocks width, depending on the subtotal width
 */
const adjustSummaryBlocks = () => {
    if (!document.querySelector(".cart-page") && !document.querySelector(".checkout-page-content--wrapper") && !document.querySelector(".ct-review-order")) return;

    const $summarySection = document.querySelector(".ct-cart--summary-details");
    const summaryDiscountSection = document.querySelector(".js-summary-order-level-discount");

    if (!$summarySection) return;

    const $summaryValues = $summarySection.querySelectorAll(".ct-cart--summary-value");
    const summaryDiscountValues = summaryDiscountSection.querySelectorAll(".ct-cart--summary-value");
    const $total = document.querySelector(".js-cart-subtotal") || document.querySelector(".js-checkout-grandtotal");

    $total.style.removeProperty("width");

    let subtotalWidth = $total ? $total.getBoundingClientRect().width : 0;
    let subtotalMargin = parseInt(window.getComputedStyle($total).getPropertyValue("margin-left"), 10) || 0;
    let summaryValuesWidth = subtotalWidth + subtotalMargin;

    if ($summarySection.querySelector(".ct-cart--entrega-zero-icon-active")) {
        const $entregaZeroIcon = $($summarySection).find(".ct-cart--entrega-zero-icon-active");

        $entregaZeroIcon[0].style.removeProperty("width");

        let entregaZeroWidth = ($entregaZeroIcon ? $entregaZeroIcon.width() : 0) + (parseInt(window.getComputedStyle($entregaZeroIcon[0]).getPropertyValue("margin-left"), 10) || 0);

        summaryValuesWidth = entregaZeroWidth >= summaryValuesWidth ? entregaZeroWidth : summaryValuesWidth;

        if (entregaZeroWidth >= summaryValuesWidth) {
            $total.style.width = `${entregaZeroWidth - subtotalMargin}px`;
        }
    }

    $summaryValues.forEach(element => {
        if (!window.mqRespond.status.tablet) {
            element.style.removeProperty("width");
            $total.style.removeProperty("width");
        } else {
            element.style.width = `${summaryValuesWidth}px`;
        }
    });

    const $summaryDiscountSection = $summarySection.querySelector(".ct-cart--summary-discounts");

    if ($summaryDiscountSection) {
        const $multishippingSplitter = $summarySection.querySelector(".ct-cart--summary-multishipping-splitter");
        const visibleChildren = Array.from($summaryDiscountSection.children).filter(
            child => !child.classList.contains("d-none")
        );
    
        if (visibleChildren.length === 0) {
            document.querySelector(".ct-cart--subtotal-section")?.classList.remove("mt-md-4");
            $multishippingSplitter?.classList.add("d-none");
        } else {
            $multishippingSplitter?.classList.remove("d-none");
            visibleChildren.slice(0, -1).forEach(child => child.classList.add("pwc-mb--20"));
        }
    }

    if (mqueryRespond.status.mobile || mqueryRespond.status.tablet) {
        const $discountArea = $summarySection.querySelector(".css-mobile-summary");

        if ($discountArea) {
            const childrenArray = Array.from($discountArea.children).filter(child => !child.classList.contains("d-none"));
            if (childrenArray.length === 0) {
                $discountArea.classList.add("d-none");
            }
        }
    }

    summaryDiscountValues.forEach(element => {
        if (!window.mqRespond.status.tablet) {
            element.style.removeProperty("width");
            $total.style.removeProperty("width");
        } else {
            element.style.width = `${summaryValuesWidth}px`;
        }
    });
};

/**
 * immediately shows minicart info after login from modal or dropdown or after reorder.
 * Does not show any notifications like during adding to cart.
 */
const fillMinicartInfo = () => {
    $cache.minicartPopover.addClass("not-show-confirmation-toast");

    $(".minicart").load($(".minicart").data("load-minicart"), () => {
        $(document).on("click", ".minicart-link", ev => {
            ev.preventDefault();
        });
    });

    setTimeout(function () {
        triggerCartUpdate();
        if ($(".product-tile").length > 0 && parseInt($(".minicart .minicart-quantity").text(), 10) !== 0) {
            $("body").trigger("product:syncTileData", getProductQtyMap());
        }
    }, 500);
    setTimeout(function () {
        $cache.minicartPopover.removeClass("not-show-confirmation-toast");
    }, 500);
};

/**
 * Update Cart Coupons List
 * @param {Object} data
 */
const updateCouponsSummary = data => {
    if (data && data.totals) {
        const $couponCodeElem = $(".coupon-code-field");
        const $couponsAndPromotions = $(".coupons-and-promos");
        $couponsAndPromotions.find(".ct-cart--applied-coupon-card").each((index, element) => {
            $(element).remove();
        });
        $couponsAndPromotions.append(data.totals.discountsHtml);

        const loyaltyCouponCodeArray = data.loyaltyCoupons ? data.loyaltyCoupons.gifts.concat(data.loyaltyCoupons.vouchers) : [];
        const loyaltyCouponsHTML = buildLoyaltyCouponCardList(loyaltyCouponCodeArray);

        verifyAndCheckAppliedCarouselCoupons(loyaltyCouponCodeArray);
        $(".couponsDesktopContainer .ct-cart--applied-coupons-wrapper").last().append(loyaltyCouponsHTML);
        $(".couponsMobileContainer .ct-cart--applied-coupons-wrapper").last().append(loyaltyCouponsHTML);
        updateCartTotals(data);
        updateApproachingDiscounts(data.approachingDiscounts);
        validateBasket(data);
        updateCartProductTilesPriceInformation(data);
        $couponCodeElem.val("").trigger("focusout");
        $couponCodeElem.removeClass("filled");
        setTimeout(() => {
            $couponCodeElem.trigger("blur");
        }, 10);
    }
};

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    if (!approachingDiscounts) { return; }

    var html = "";
    $(".approaching-discounts").empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += "<div class=\"single-approaching-discount text-center\">"
                + item.discountMsg + "</div>";
        });
    }
    $(".approaching-discounts").append(html);
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    if (data) {
        if (data.resources) {
            $(".number-of-items").empty().append(data.resources.numberOfItems);
            $(".minicart-link").attr({
                "aria-label": data.resources.minicartCountOfItems
            });
        }

        if (data.totals) {
            $(".shipping-cost").empty().append(data.totals.totalShippingCost);
            $(".tax-total").empty().append(data.totals.totalTax);
            $(".grand-total").empty().append(data.totals.grandTotal);
            $(".sub-total").empty().append(data.totals.subTotal);

            if (data.totals.orderLevelDiscountTotal.value > 0) {
                $(".order-discount").removeClass("hide-order-discount");
                $(".order-discount-total").empty()
                    .append("- " + data.totals.orderLevelDiscountTotal.formatted);
            } else {
                $(".order-discount").addClass("hide-order-discount");
            }

            if (data.totals.shippingLevelDiscountTotal.value > 0) {
                $(".shipping-discount").removeClass("hide-shipping-discount");
                $(".shipping-discount-total").empty().append("- " +
                    data.totals.shippingLevelDiscountTotal.formatted);
            } else {
                $(".shipping-discount").addClass("hide-shipping-discount");
            }
        }

        const minicartQtyTotal = data.quantityTotal;
        const $minicartQty = $(".minicart-quantity");

        if (minicartQtyTotal) {
            $minicartQty.empty().append(minicartQtyTotal);
            $minicartQty.toggleClass("minicart-quantity--expanded", minicartQtyTotal >= MINICART_QUANTITY_LIMIT);
        }

        //Updates the cart summary
        updateCartSummary(data);
    }
}

/**
 * Update product price information for cart products
 * @param {Object} data
 */
const updateCartProductTilesPriceInformation = data => {
    const cartItems = data.items;
    let $cartTiles = $(".js-cart-product-list").find(".ct-cart-tile");

    if (cartItems && cartItems.length) {
        $cartTiles.each((index, elem) => {
            let $this = $(elem);
            const productID = $this.attr("data-pid");
            const item = cartItems.find(product => product.id == productID);
            if (item) {
                const {priceTotal} = item;
                $this.find(".ct-cart-tile-total").text(priceTotal.price);
                $this.find(".js-product-price").html(productPriceTemplate(item));
            }
        });
    }
};

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (!data || !data.valid) { return; }

    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = "<div class=\"alert alert-danger alert-dismissible valid-cart-error " +
                "fade show\" role=\"alert\">" +
                "<button type=\"button\" class=\"close\" data-dismiss=\"alert\" aria-label=\"Close\">" +
                "<span aria-hidden=\"true\">&times;</span>" +
                "</button>" + data.valid.message + "</div>";

            $(".cart-error").append(errorHtml);

            //GTM logic - Start
            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                detail: {
                    "success": false,
                    "messageContent": data.valid.message
                }
            }));
            //GTM logic - End
        } else {
            $(".cart").empty().append("<div class=\"row\"> " +
                "<div class=\"col-12 text-center\"> " +
                "<h1>" + data.resources.emptyCartMsg + "</h1> " +
                "</div> " +
                "</div>"
            );
            $(".number-of-items").empty().append(data.resources.numberOfItems);

            //GTM logic - Start
            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                detail: {
                    "success": false,
                    "messageContent": data.resources.emptyCartMsg
                }
            }));
            //GTM logic - End

            const $minicartQuantity = $(".minicart-quantity");

            $minicartQuantity.empty().append(data.quantityTotal);
            $minicartQuantity.toggleClass("minicart-quantity--expanded", data.quantityTotal >= MINICART_QUANTITY_LIMIT);
            $(".minicart-link").attr({
                "aria-label": data.resources.minicartCountOfItems
            });
            $(".minicart .ct-popover").removeClass("show");
        }

        $(".checkout-btn").addClass("disabled");
    } else {
        $(".checkout-btn").removeClass("disabled");
    }
}

/**
 * Verifies if for the current master there are any variants added to the cart. If yes, it verifies based on the user selection which product variant should appear in the quickview
 * @param {Object} $this
 */
const getSelectedProductIDForQuickview = $this => {
    const $productTile = $this.closest(".product-tile");
    const isColorSwatchSelected = $this.closest(".color-swatches").length != 0;
    const productsAddedToCartString = $productTile.attr("data-product-added-to-cart");
    const listOfIDs = productsAddedToCartString ? productsAddedToCartString.split(",") : [];
    let selectedID = listOfIDs && listOfIDs.length ? listOfIDs[0] : null;

    if (isColorSwatchSelected && listOfIDs && listOfIDs.length) {
        selectedID = null;
        const colorSelected = $this.attr("data-color-value");
        const variantsMappingString = $this.closest(".product-tile").attr("data-variants-mapping");

        if (colorSelected && variantsMappingString) {
            const variantsMapping = JSON.parse(variantsMappingString);
            const listOfAvailableVariants = variantsMapping.filter(item => {
                return item.color == colorSelected;
            });

            for (let i = 0; i < listOfAvailableVariants.length; i++) {
                if (productsAddedToCartString.includes(listOfAvailableVariants[i].id)) {
                    selectedID = listOfAvailableVariants[i].id;
                    break;
                }
            }
        }
    }

    return selectedID;
};
/**
 * Verifies if for the current master there are Two or more variants added to the cart. If yes, we should display the master product in QuickView
 * @param {Object} $this
 */
const checkIfProductMasterToDisplay = $this => {
    const $productTile = $this.closest(".product-tile");
    const productsAddedToCartString = $productTile.attr("data-product-added-to-cart");
    if (!productsAddedToCartString) return false;

    const listOfIDs = productsAddedToCartString ? productsAddedToCartString.split(",") : [];
    if (listOfIDs && listOfIDs.length <= 1) return false;

    const variantsMappingString = $this.closest(".product-tile").attr("data-variants-mapping");
    const variantsMapping = JSON.parse(variantsMappingString);
    let variationsInCart = 0;

    variantsMapping.forEach(variant => {
        if (listOfIDs.indexOf(variant.id) != -1) {
            variationsInCart++;
        }
    });

    return variationsInCart <= 1 ? false : true;
};

/**
 * Compare basket content with the alternative products that should appear in the modal
 * @param {Array} alternativeProducts
 */
const removeAlternativeProductsPartOfBasket = alternativeProducts => {
    if (!alternativeProducts) { return null; }

    const availableAlternatives = [];
    let isPartOfBasket = false;

    for (let i = 0; i < alternativeProducts.length; i++) {
        const productID = alternativeProducts[i].id || alternativeProducts[i];
        isPartOfBasket = globalUtil.isProductInBasket(productID);

        if (!isPartOfBasket) {
            availableAlternatives.push(alternativeProducts[i]);
        }
    }

    return availableAlternatives;
};

/**
 * @function
 * @description - Blur quantity input after update
 * @param {Object} input - JavaScript Object of quantity input updated
 */
const blurQtyInput = input => {
    if (!input) { return; }
    input.blur();
};

/**
 * Displays the invalid coupons warning, asking user if he wants to processed with invalid coupons or cancel
 * @param {number} numberOfInvalidCoupons
 * @param {function} afterInjectBody
 */
const displayInvalidCouponsModalWarning = (numberOfInvalidCoupons, afterInjectBody) => {
    const $invalidCouponsModal = $("#invalid-coupons-modal");
    $invalidCouponsModal.data("params", { numberOfInvalidCoupons });
    $invalidCouponsModal.data("after-inject-body", afterInjectBody);

    $invalidCouponsModal.modal("show");
    updateCartSummaryModalClass(true);
};

/**
 * Add/Remove Cart Summary class, that handles the css style when using modals
 * @param {Boolean} modalOn Boolean to indicate if toggling the modal on or off
 */
const updateCartSummaryModalClass = (modalOn) => {
    // update is not necessary for safari
    if (navigator.userAgent.match(/safari/i) != null && navigator.userAgent.match(/chrome/i) == null) {
        return;
    }
    const cartSummary = document.getElementsByClassName("ct-cart--summary-wrapper");
    if (cartSummary && cartSummary.length > 0) {
        const hasScroll = document.documentElement.scrollHeight > document.documentElement.clientHeight;
        if (modalOn && hasScroll) {
            cartSummary[0].classList.add("ct-cart--summary-wrapper-modal");
        }
        else if (!modalOn && hasScroll) {
            cartSummary[0].classList.remove("ct-cart--summary-wrapper-modal");
        }
    }
};

/**
 * Gets the carousel header or text box text
 * @param {Object} $elem carousel element 
 * @returns {String|false} returns the title of the carousel, or false if doesn't exist
 */
const getCarouselTitle = ($elem) => {
    var carouselTitle = false; 
    var $carousel = $elem.closest(".experience-commerce_layouts-productCarousel");

    if ($carousel.length) {
        var $textbox = $carousel.prevAll(".experience-commerce_assets-textbox").first();
        var $heading = $carousel.find(".product-carousel-heading");
        if ($textbox.length) {
            // Carousel has a text component on top
            carouselTitle = $textbox.text().trim();
        } else if ($heading.length) {
            // Carousel is using the heading
            carouselTitle = $heading.text().trim();
        }
    }
    
    return carouselTitle;
};

/**
 * Get information necessary for datalayer request
 * @param {Object} $elem target element 
 * @param {String} gtmList list name of the page
 * @returns {Object} returns the index of the target element, and the list
 */
const getGTMData = ($elem, gtmList) => {
    var gtmIndex = null;
    var carouselTitle = null;

    // If list is "default", page wasn't configured so use the full page id for Page Designer
    if (gtmList === "default") {
        var $fullPage = $(".fullpage").first();
        if ($fullPage.length) {
            gtmList = $fullPage.attr("id");
        }
    }

    let $slickSlide = $elem.closest(".slick-slide"); // Product carousels
    let $productTile = $elem.closest(".productTile"); // PLP
    let $isMinicart = $elem.closest(".minicart"); // Minicart
    let $isList = $elem.closest(".product"); // Lists like favorite list
    let $isCheckout = $elem.closest(".product-info"); // Checkout
    let $isModal = $elem.closest(".js-product-quickview"); // Is modal
    let $isPDP = $(".page[data-page-type='pdp']"); // Is PDP

    if ($slickSlide.length > 0) {
        gtmIndex = $slickSlide.data("slick-index") + 1;
        
        if ($slickSlide.parents(".js-productcarousel").length > 0) {
            carouselTitle = getCarouselTitle($elem);
            // If carousel has title, append it to the list name
            if (carouselTitle) {
                gtmList = gtmList + " - " + carouselTitle;
            }
        }
    } else if ($productTile.length > 0) {
        gtmIndex = $productTile.data("idx");
    } else if ($isMinicart.length > 0) {
        gtmIndex = $elem.index(".minicart-product-line") + 1;
    } else if ($isList.length > 0) {
        gtmIndex = $isList.index(".product") + 1;
    } else if ($isCheckout.length > 0) {
        gtmIndex = $isCheckout.index(".product-info") + 1;
    } else if ($isModal.length > 0) {
        gtmIndex = $isModal.data("gtm-index") || null;
        gtmList = $isModal.data("gtm-list") || null;
    } else if ($isPDP.length > 0) {
        // On PDP, we only have one product so the index is always 1
        gtmIndex = 1; 
    }

    return { gtmIndex, gtmList };
}; 

export {
    init,
    addToCart,
    resumeAddToCart,
    chooseBonusProducts,
    getAddToCartUrl,
    initWindowScrollImpact,
    getPidValue,
    getQuantitySelected,
    getQuantitySelector,
    getOptions,
    checkProductVariations,
    handlePostCartAdd,
    miniCartReportingUrl,
    parseHtml,
    closeArea,
    getProductToAdd,
    getProductQtyMap,
    updateProductQtyMap,
    updateMinicartInfo,
    updatedQuantityCallback,
    updateCartPriceInformation,
    triggerProductRemoval,
    displayQtyInput,
    displayConfirmationToast,
    startSpinner,
    stopSpinner,
    triggerCartUpdate,
    updateCartSummary,
    adjustProductListBottomSpacing,
    handlePDPAddToCartModal,
    productPriceTemplate,
    initQuickViewQtyInput,
    setCartNotesDisplay,
    getNotesArea,
    adjustSummaryBlocks,
    fillMinicartInfo,
    getSelectedProductIDForQuickview,
    refreshProductQtyMap,
    removeAlternativeProductsPartOfBasket,
    checkIfProductMasterToDisplay,
    updateCouponsSummary,
    updateCartTotals,
    updateApproachingDiscounts,
    validateBasket,
    updateCartProductTilesPriceInformation,
    resetProductNote,
    consentConfirmationBtnClickEvent,
    consentTermsAndConditionsInputEvent,
    blurQtyInput,
    displayInvalidCouponsModalWarning,
    updateCartSummaryModalClass,
    getGTMData
};
